import React, { memo, useEffect, useState } from 'react'

import { Box, Grid, Link, Typography } from '@mui/material'
import BackgroundImageRegistration from '../../../../assets/img/BackgroundImageRegistration.jpg'
import { GetContact } from '../../../../redux/api/footer'
import { formatCellAndTell } from '../../../../utils/utils'
import { WhatsApp } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'

function Footer({ contact }) {
    const { t } = useTranslation()
    return (
        <Box
            sx={{
                backgroundImage: `url(${BackgroundImageRegistration})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                justifyContent: 'flex-end',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    backgroundColor: '#000',
                    opacity: 0.5,
                    px: 2,
                    py: 1.5,
                }}
            >
                <Typography variant="body1" color="white" fontWeight="bold" fontSize={15} lineHeight="28px">
                    Contato
                </Typography>

                {contact && (
                    <Box color="white" display="flex" flexDirection="column" fontSize={13} lineHeight="20px" mt={1}>
                        {contact.contactEmail && (
                            <Typography variant="body2" fontSize={13}>{contact.contactEmail}</Typography>
                        )}

                        <Typography variant="body2" fontSize={13} >
                            {contact.contactPhoneNumber && formatCellAndTell(contact.contactPhoneNumber)}
                            {contact.contactPhoneNumber && contact.contactPhoneNumber2 && ' | '}
                            {contact.contactPhoneNumber2 &&
                                (contact.isContactPhoneNumber2Whatsapp ? (
                                    <Link
                                        href={`https://api.whatsapp.com/send?phone=${contact.contactPhoneNumber2.replace(/\D/g, '')}`}
                                        target="_blank"
                                        rel="noopener"
                                        underline="none"
                                        color="inherit"
                                        display="inline-flex"
                                        alignItems="center"
                                    >
                                        <WhatsApp sx={{ fontSize: 20, mx: 0.5, mb: '3px' }} />
                                        {t('FIELD_REGISTER_MOBILE_PHONE')} {formatCellAndTell(contact.contactPhoneNumber2)}
                                    </Link>
                                ) : (
                                    `${t('FIELD_REGISTER_MOBILE_PHONE')} ${formatCellAndTell(contact.contactPhoneNumber2)}`
                                ))}
                        </Typography>

                        {contact.startAttendancePeriod && (
                            <Typography variant="body2" fontSize={13}>
                                De {t(contact.startAttendanceDay?.value)} a {t(contact.endAttendanceDay?.value)} das{' '}
                                {contact.startAttendancePeriod.slice(0, 5)} às {contact.endAttendancePeriod.slice(0, 5)} <br /> (exceto{' '}
                                {t(contact.attendancExceptions?.value)})
                            </Typography>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default memo(Footer)
